import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import ReelGroup from "../../core/src/views/ReelGroup";
import GameEvents from "../../core/src/const/GameEvents";
import SpinModel from "../../core/src/model/SpinModel";
import App from "../../core/src/App";
import { Tween } from "./../../core/src/Tween";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import VendorSpinStartState from "./VendorSpinStartState";

export default class RecoverSpinStartState extends VendorSpinStartState {

    startSpin() {
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.disableSwipeSpin();
        super.initReel();
        Tween.delayedCall(0.2, () => {
            this.skipRequest();
        });
        // SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, true, 1);
        App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);
    }

    skipRequest() {
        if (!SpinModel.isInFreespins()) {
            UIController.updateFields(UIUpdateEvent.Balance);
            SpinModel.spinFinished = false;
        } 
        this.exit();
    }
}
